import gsap from 'gsap'

class Testimonials {
  constructor(section) {
    this.section = section
    this.items = section.querySelectorAll('[data-testimonials-item]')
		this.images = section.querySelectorAll('[data-testimonials-image]')
    this.paginationButtons = section.querySelectorAll('[data-testimonials-pagination-button]')
		this.prevButton = section.querySelector('[data-testimonials-prev]')
		this.nextButton = section.querySelector('[data-testimonials-next]')
    this.currentIndex = 0
    this.totalSlides = this.items.length
    this.autoPlayInterval = null
    this.autoPlayDelay = 10000
		this.isTransitioning = false
    this.isAutoPlaying = true
    this.touchStartX = 0
    this.touchEndX = 0
    this.minSwipeDistance = 50

    this.init()
  }

  init() {
		this.setFirstSlideActive()
		
    if (this.totalSlides <= 1) return

    this.bindEvents()
    // this.startAutoPlay()
  }

  bindEvents() {
    this.paginationButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.goToSlide(index)
      })
    })

    this.section.addEventListener('mouseenter', () => {
      this.pauseAutoPlay()
    })

    this.section.addEventListener('mouseleave', () => {
      this.resumeAutoPlay()
    })

    this.section.addEventListener('focusin', () => {
      this.pauseAutoPlay()
    })

    this.section.addEventListener('focusout', () => {
      this.resumeAutoPlay()
    })

		this.prevButton.addEventListener('click', () => {
			this.prevSlide()
		})

		this.nextButton.addEventListener('click', () => {
			this.nextSlide()
		})

		// Add swipe event listeners
		this.bindSwipeEvents()
  }

  bindSwipeEvents() {
    this.section.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX
    }, { passive: true })

    this.section.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX
      this.handleSwipe()
    }, { passive: true })
  }

  handleSwipe() {
    const swipeDistance = this.touchEndX - this.touchStartX

    if (Math.abs(swipeDistance) < this.minSwipeDistance) {
      return
    }

    if (swipeDistance > 0) {
      this.prevSlide()
    } else {
      this.nextSlide()
    }
  }

	setFirstSlideActive() {
		this.items[0].classList.add('active')
		this.images[0].classList.add('active')
		this.paginationButtons[0].classList.add('active')
		this.allText = this.section.querySelectorAll('[data-testimonials-item-quote] .line, [data-testimonials-item-author] .line')
		this.slideText = this.items[0].querySelectorAll('[data-testimonials-item-quote] .line, [data-testimonials-item-author] .line')

		gsap.set(this.allText, {
			yPercent: 105
		})

		gsap.set(this.slideText, {
			yPercent: 0
		})
	}

  goToSlide(index) {
    if (index === this.currentIndex || index < 0 || index >= this.totalSlides)
      return

		if (this.isTransitioning) return
		this.isTransitioning = true

    // Remove active class from current slide and button
    this.items[this.currentIndex].classList.remove('active')
    this.paginationButtons[this.currentIndex].classList.remove('active')
		this.images[this.currentIndex].classList.remove('active')

		const tl = gsap.timeline()
		const currentSlide = this.items[this.currentIndex]
		const newSlide = this.items[index]
		const currentText = this.items[this.currentIndex].querySelectorAll('[data-testimonials-item-quote] .line, [data-testimonials-item-author] .line')
		const newText = this.items[index].querySelectorAll('[data-testimonials-item-quote] .line, [data-testimonials-item-author] .line')

		tl.set(newSlide, {
			opacity: 1
		})

		tl.fromTo(currentSlide, {
			opacity: 1
		}, {
			opacity: 0,
			duration: 0.8,
			ease: 'expo',
			onComplete: () => {
				this.isTransitioning = false
			}
		})

		tl.fromTo(newText, {
			yPercent: 105
		}, {
			yPercent: 0,
			duration: 1.6,
			stagger: 0.05,
			ease: 'expo'
		}, '-=0.6')

    // Update current index
    this.currentIndex = index

    // Add active class to new slide and button
    this.items[this.currentIndex].classList.add('active')
    this.paginationButtons[this.currentIndex].classList.add('active')
		this.images[this.currentIndex].classList.add('active')

    // Reset auto-play timer
    // this.resetAutoPlay()
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.totalSlides
    this.goToSlide(nextIndex)
  }

  prevSlide() {
    const prevIndex = this.currentIndex === 0 ? this.totalSlides - 1 : this.currentIndex - 1
    this.goToSlide(prevIndex)
  }

  startAutoPlay() {
    if (!this.isAutoPlaying) return

    this.autoPlayInterval = setInterval(() => {
      this.nextSlide()
    }, this.autoPlayDelay)
  }

  pauseAutoPlay() {
    this.isAutoPlaying = false
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval)
      this.autoPlayInterval = null
    }
  }

  resumeAutoPlay() {
    this.isAutoPlaying = true
    this.startAutoPlay()
  }

  resetAutoPlay() {
    this.pauseAutoPlay()
    this.resumeAutoPlay()
  }

  destroy() {
    this.pauseAutoPlay()
    // Remove event listeners if needed
  }
}

export const initTestimonials = () => {
  const sections = document.querySelectorAll('[data-testimonials]')

  sections.forEach((section) => {
		document.fonts.ready.then(() => {
			new Testimonials(section)
		})
  })
}

export default () => {}
